<template>
  <sdCards :title="$t('pages.apps.pricing.title')">
    <a-form layout="vertical" :model="formData" @submit="handleSubmit">
      <a-row :gutter="16">
        <a-col :span="8">
          <a-form-item :label="$t('common.price')">
            <a-input v-model:value="app.price" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :label="$t('common.vat')">
            <a-input v-model:value="app.vat" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :label="$t('common.currency')">
            <a-select v-model:value="app.currency">
              <a-select-option :value="currency.code" v-for="currency in currencies" :key="currency">
                {{ currency.code }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :label="$t('pages.apps.pricing.package')">
            <a-select v-model:value="app.package_code">
              <a-select-option :value="app_package.code" v-for="app_package in packages" :key="app_package">
                {{ $store.state.i18n.i_lang == 'en' ? app_package.name_en : app_package.name }}
                {{
                  app_package.price > 0
                    ? '(' +
                      app_package.price +
                      ' ' +
                      app_package.currency +
                      ' ' +
                      app_package.day +
                      '/' +
                      app_package.period +
                      ')'
                    : ''
                }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8" v-if="decoder($store.state.auth.is_root) == 1">
          <a-form-item :label="$t('pages.apps.pricing.inapp-purchase')">
            <a-switch v-model:checked="app.inapp_purchase" />
            {{ app.inapp_purchase == true ? $t('common.yes') : $t('common.no') }}
          </a-form-item>
        </a-col>
      </a-row>
      <a-form-item label="&nbsp;">
        <a-button type="primary" :loading="iconLoading" html-type="submit"> {{ $t('common.save') }} </a-button>
      </a-form-item>
    </a-form>
  </sdCards>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'BlankPage',
  components: {},
  data() {
    return {
      packages: [],
      currencies: [],
      iconLoading: false,
      formData: {},
      app_id: this.$route.params.id,
    };
  },
  methods: {
    handleSubmit() {
      this.formData = {
        price: this.app.price,
        vat: this.app.vat,
        currency: this.app.currency,
        inapp_purchase: this.app.inapp_purchase,
        package_code: this.app.package_code,
        id: this.app_id,
      };

      this.$appAxios.post(this.$endpoints.app_price_update, this.formData).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
      });
    },
    getPackage() {
      this.$appAxios.post(this.$endpoints.app_package_all_get, { id: this.app_id }).then((resp) => {
        if (resp.data.status) {
          this.packages = resp.data.data;
        }
      });
    },
    getCurrencies() {
      this.$appAxios.post(this.$endpoints.app_currency_get, { id: this.app_id }).then((resp) => {
        if (resp.data.status) {
          this.currencies = resp.data.data;
        }
      });
    },
    decoder(value) {
      return atob(value);
    },
  },
  mounted() {
    this.getPackage();
    this.getCurrencies();
  },
  created() {},
  computed: {
    ...mapGetters({
      app: 'application/app_detail',
    }),
  },
};
</script>
